module.exports = __webpack_public_path__ + "static/media/icons_Bilan langue et DAM.668d79b3.svg";